import type { TOrientation, TSize, TSizeVariant } from "@/types/common";

import {
  StyledFigure,
  StyledWrapperButton,
  StyledWrapperCard,
  StyledWrapperContent,
  StyledWrapperContentText,
  StyledWrapperDescription,
  StyledWrapperFigure,
  StyledWrapperTitle,
} from "./styles";

export interface IProductCardGallerySkeleton {
  sizeVariant: TSizeVariant;
  size?: TSize;
  orientation?: TOrientation;
  key?: any;
}

const ProductCardGallerySkeleton = ({
  sizeVariant,
  size,
  orientation = "vertical",
  ...rest
}: IProductCardGallerySkeleton) => {
  if (!sizeVariant) {
    throw new TypeError("sizeVariant is required");
  }
  return (
    <StyledWrapperCard $size={size} $orientation={orientation} $sizeVariant={sizeVariant} {...rest}>
      <StyledWrapperFigure>
        <StyledFigure />
      </StyledWrapperFigure>
      <StyledWrapperContent>
        <StyledWrapperContentText>
          <StyledWrapperTitle />
          <StyledWrapperDescription />
        </StyledWrapperContentText>
        <StyledWrapperButton />
      </StyledWrapperContent>
    </StyledWrapperCard>
  );
};

export default ProductCardGallerySkeleton;
